<script>
require('@/css/style.css')
export default {
  props: [
    'index',
    'valid',
    'x1',
    'x2',
    'y',
    'w',
    'h',
    'marginX',
    'marginY'
  ],
  data () {
    return {
      isBrotherArea: false
    }
  },
  created () {
    this.isBrotherArea = false
  },
  watch: {
  },
  methods: {
    mouseOverNode () {
      this.isBrotherArea = true
      this.$emit('overSwappingNode', this.nodeData, this.isBrotherArea)
    },
    mouseOutNode () {
      this.isBrotherArea = false
      this.$emit('overSwappingNode', this.nodeData, this.isBrotherArea)
    },
    releaseNode () {
      this.isBrotherArea = false
      this.$emit('releaseNode', this.index)
    }
  }
}
</script>
<style scoped>
.brother-color {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  border-radius: 10px;
  opacity: 0.2;
  z-index: 2;
}
.brother-highlight {
  background-color: #96c3fa;
  z-index: 10;
}
</style>
<template>
<div>
  <!-- 兄弟Nodeの並び替えのあたり判定-->
  <div v-if="valid" v-bind:class="{'brother-highlight' : isBrotherArea}"
  class="brother-color" :style="{left:x1 + 'px', top:y + 'px', width: x2-x1 + 'px', height:2*(h - marginY)/3 + 'px'}" v-on:mouseup="releaseNode()" v-on:mouseover="mouseOverNode()" v-on:mouseout="mouseOutNode()">
  </div>
</div>
</template>



// WEBPACK FOOTER //
// src/pages/tree/graph/GraphBrother.vue